/*
 * Copyright (c) 2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

export const elements = {
    TEXTBOX: 'TEXTBOX',
    SLIDER: 'SLIDER',
    HEADER: 'HEADER',
    DROPDOWN: 'DROPDOWN',
    GRID_LAYOUT_3_3: 'GRID_LAYOUT_3_3',
    GRID_LAYOUT_1_2: 'GRID_LAYOUT_1_2'
};

export const pageGrid = {
    gridRowHeight: 18, // alt 64
    gridGap: 10, // alt 10
    gridCols: 36, // alt 12
    minColSize: 3, // alt 12
};


export const schemaVersions = "5.4";


export const names = {
    container: "Container",
    service: "Service",
    page: "Page",

}


export const Colors = {
    twin: {
        bg: "bg-blue-50",
        text: "text-blue-600"
    },
    attribute: {
        bg: "bg-yellow-50",
        text: "text-yellow-700"
    },
    stack: {
        bg: "bg-purple-50",
        text: "text-purple-600"
    },
    process: {
        bg: "bg-orange-50",
        text: "text-orange-600"
    },
    layout: {
        bg: "bg-fuchsia-50",
        text: "text-fuchsia-600"
    }
}

export const GlobaleStyles = {
    contentBox: "mx-auto max-w-4xl px-1.5 ",
    isReadOnly: " !cursor-default text-gray-500 !border border-stone-100 ",
    isEmbedded: " !border-none !h-full !shadow-none ",
    processInput: " bg-sky-50 text-blue-600 !rounded-lg text-sm hover:ring-1 hover:ring-inset font-normal",
}


export const FilterTypes = [
    {label: 'ist genau', value: "isexact", iconName: "PiEquals"},
    {label: 'ist nicht', value: "isnot", iconName: "PiNotEquals"},
    {label: 'ist', value: "is", iconName: "PiWaves"},
    {label: 'größer als', value: "greaterThan", iconName: "PiGreaterThan"},
    {label: 'größer gleich', value: "greaterOrEqual", iconName: "PiGreaterThanOrEqual"},
    {label: 'kleiner als', value: "lessThan", iconName: "PiLessThan"},
    {label: 'kleiner gleich', value: "lessThanOrEqual", iconName: "PiLessThanOrEqual"},
    {label: 'beginnt mit', value: "startsWith", iconName: "TbBracketsContainStart"},
    {label: 'ended mit', value: "endsWith", iconName: "TbBracketsContainEnd"},
    {label: 'enthält', value: "contains", iconName: "TbBracketsContain"},
]

